import React from "react";
import Visit from "./Visit/Visit";
import Visit2 from "./Visit/Visit2";
import MessageStats from "./MessageStats/MessageStats";
import ChatbotStats from "./ChatbotStats/ChatbotStats";

import './Dashboard.css';
import CurriculumStats from "./CurriculumStats/CurriculumStats";
import MessageStats2 from "./MessageStats/MessageStats2";
import CurriculumStatsAreas from "./CurriculumStats/CurriculumStatsAreas";
import ChatbotUsersTable from "../../components/ChatbotUserList/ChatbotUsersTable";
import ChatbotUsersChart from "../../components/ChatbotUserList/ChatbotUsersChart";
import ChatbotUsersTimelineChart from "../../components/ChatbotUserList/ChatbotUsersTimelineChart";

const Dashboard = () => {
  return (
    <div className="container-fluid dashboard-container">
      <div className="row g-2 mt-1">
        <div className="col-sm-12 col-md-3">
          <Visit />
        </div>
        <div className="col-sm-12 col-md-3">
          <MessageStats2 />
        </div>
        <div className="col-sm-12 col-md-3">
          <CurriculumStats />
        </div>
        <div className="col-sm-12 col-md-3">
          <ChatbotUsersTimelineChart />
      </div>
      </div>

      <div className="row g-5">
        <div className="col-sm-12 col-md-6 col-lg-4">
          <ChatbotStats />
        </div>        
        <div className="col-sm-12 col-md-6 col-lg-4">
          <CurriculumStatsAreas />
        </div>
        <div className="col-sm-12 col-md-6 col-lg-4">
          <MessageStats />
        </div>
      </div>
      
    </div>
  );
};

export default Dashboard;
